export default __webpack_public_path__ + "static/media/painscale_10.a78df0ec.png";